import React from 'react';
import { palette } from '../theme';
import { Spinner } from '../spinner';
import { ActionButton } from '../buttons';
import { Modal } from './modal';

interface LoadingModalProps {
  open: boolean;
  title: string;
  subtitle?: string;
  cancelLabel?: string;
  onCancel?: () => void;
}

export const LoadingModal: React.FC<LoadingModalProps> = ({ open, title, subtitle, cancelLabel, onCancel }) => (
  <Modal open={open}>
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 16,
        padding: '8px 8px 0'
      }}
    >
      <Spinner size={40} />
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
        <span
          style={{
            fontSize: 18,
            fontWeight: 700,
            color: palette.primitives.slate.slate900,
            textAlign: 'center'
          }}
        >
          {title}
        </span>
        {subtitle && (
          <span
            style={{
              fontSize: 14,
              fontWeight: 400,
              color: palette.primitives.slate.slate500,
              textAlign: 'center',
              lineHeight: 1.45
            }}
          >
            {subtitle}
          </span>
        )}
      </div>
      {cancelLabel && (
        <ActionButton fullWidth onClick={onCancel} style={{ marginTop: 8 }}>
          {cancelLabel}
        </ActionButton>
      )}
    </div>
  </Modal>
);
